var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerships(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.503,
    height: 78.517,
    viewBox: "0 0 118.503 78.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partnerships",
    transform: "translate(-6.5 -14.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11355",
    "data-name": "Path 11355",
    d: "M48.751,72.415,64.664,86.081a5.5,5.5,0,0,0,4.853,1.3c.766-.23,2.273-.664,2.095-3.832L55.494,70.091a2.5,2.5,0,0,1-.332-3.576,2.53,2.53,0,0,1,3.6-.332L78.995,83.067a3.6,3.6,0,0,0,4.726-5.441L63.873,59.694a2.578,2.578,0,0,1-.179-3.627,2.547,2.547,0,0,1,3.6-.179L87.143,73.846a8.5,8.5,0,0,1,1.43,1.737,2.817,2.817,0,0,0,2.81-.511,4.845,4.845,0,0,0,.69-6.233c-1.354-2.12-21.253-23.909-34.587-38.316L47.141,39.259a10.59,10.59,0,0,1-14.586-15.3c1.839-1.992,4.036-4.317,6.233-6.59H13.04v38.8l32.7,29.044A11.849,11.849,0,0,0,54.5,88.355a5.2,5.2,0,0,0,3.448-1.328L45.43,76.3a2.555,2.555,0,0,1,3.321-3.883Z",
    transform: "translate(9.389 3.948)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11356",
    "data-name": "Path 11356",
    d: "M23.1,38.91a5.545,5.545,0,0,0,7.484.383L42.8,28.973a2.576,2.576,0,0,1,3.525.23c4.751,5.134,24.982,27.051,33.309,36.6A19.716,19.716,0,0,0,82.186,63a16.276,16.276,0,0,1,4.24-4.138V21.438c-4.751.1-14.713-.2-22.862-3.908-9.5-4.342-23.577-3.04-28,1.047-.358.332-.766.69-1.149,1.073a2.47,2.47,0,0,1-1.558,1.507c-3.219,3.167-6.948,7.127-9.834,10.218A5.5,5.5,0,0,0,23.1,38.91Z",
    transform: "translate(22.648 0.006)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11357",
    "data-name": "Path 11357",
    d: "M9.35,14.828A2.344,2.344,0,0,0,7,17.178V60.909a2.344,2.344,0,0,0,2.35,2.35h5.62a2.344,2.344,0,0,0,2.35-2.35V17.178a2.344,2.344,0,0,0-2.35-2.35Z",
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11358",
    "data-name": "Path 11358",
    d: "M48.96,17.178V60.909a2.344,2.344,0,0,0,2.35,2.35h5.62a2.344,2.344,0,0,0,2.35-2.35V17.178a2.344,2.344,0,0,0-2.35-2.35H51.31A2.344,2.344,0,0,0,48.96,17.178Z",
    transform: "translate(65.223 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerships);
export default __webpack_public_path__ + "static/media/partnerships.20f9564ae6bcb167c5cea895bcee0bb4.svg";
export { ForwardRef as ReactComponent };